import { createStore } from 'redux'
import reducer from './combinedReducers'
import { composeWithDevTools } from 'redux-devtools-extension'

const enhancer = composeWithDevTools()

export default createStore(reducer, enhancer)
